/**
 * @file コンポーネント：リスト DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル読み込み
import { StyledList, StyledListItem } from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ReactDOM
    return (
        <StyledList>
            {props.list.map((item, index) =>
                props.dangerouslySetInnerHTML === true ? (
                    <StyledListItem
                        dangerouslySetInnerHTML={{ __html: item }}
                        data-font-size={props.fontSize}
                        data-icon={props.icon}
                        data-icon-weight={props.iconWeight}
                        data-list-style-type={
                            props.icon ? "icon" : props.listStyleType
                        }
                        data-on-color={props.onColor}
                        key={"list-" + index}
                    />
                ) : (
                    <StyledListItem
                        data-font-size={props.fontSize}
                        data-icon={props.icon}
                        data-icon-weight={props.iconWeight}
                        data-list-style-type={
                            props.icon ? "icon" : props.listStyleType
                        }
                        data-on-color={props.onColor}
                        key={"list-" + index}
                    >
                        {item}
                    </StyledListItem>
                )
            )}
        </StyledList>
    );
};
